import React from 'react';
import { useAtomValue } from '@exodus/headless-ui';
import { toAssetAtom } from '../../../atoms/index.js';
const AssetLabel = ({ Component, className, style }) => {
    const toAsset = useAtomValue(toAssetAtom);
    if (Component) {
        return React.createElement(Component, { side: "to", asset: toAsset, className: className, style: style });
    }
    return null;
};
export default AssetLabel;
